// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"83b8f5ab","177":"727c1312","288":"ef03eb5a","480":"676699e0","972":"31a3f8c3"}[chunkId] + ".chunk.js";
};